export enum SignOrders {
  Nobody = 'nobody',
  OnlyOwner = 'only_owner',
  OwnerFirst = 'owner_first',
  SignersFirst = 'signers_first',
  OnlySigners = 'only_signers',
  Everyone = 'everyone',
  Multiple = 'multiple'
}
